// Client V2 common imports
const {
  USER_FOLLOWING_CHANGE_PENDING,
  USER_FOLLOWING_CHANGE
} = require('client-v2/common/models/user/actions')
// Container imports
const { adjustFollowingCount } = require('./actions')

function adjustProfileUserFollowersCountMiddleware() {
  return store => next => action => {
    if (action.type === USER_FOLLOWING_CHANGE) {
      const { profileUser } = store.getState()
      const { userId, isFollowing } = action.payload
      if (
        userId === profileUser.id &&
        isFollowing !== USER_FOLLOWING_CHANGE_PENDING
      ) {
        const amount = isFollowing ? 1 : -1
        store.dispatch(adjustFollowingCount(amount))
      }
    }
    next(action)
  }
}

module.exports = adjustProfileUserFollowersCountMiddleware
